module.exports = __webpack_public_path__ + "img/home-event.cdad6a28.svg";